import React, { useState, useEffect, useContext } from "react";
import axios from 'axios'

import { GlobalContext, HOST } from "./context/GlobalContext"

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'

import Select from 'react-select';

import './App.css';
import { BookFill, PencilFill, X } from "react-bootstrap-icons";

const PARTIDAS_UPDATE_API = HOST + '/api/inv/ordenDetalle/update'
const PARTIDAS_MASSIVE_API = HOST + '/api/inv/ordenCompra/carga'

const CURRENCY_FORMAT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

function Partidas({ orden, readOnly, setShowDetail }) {
  const { setGlobalLoading, setShowMesage, setMailTitle, setMailBody, setCallback, getLibrosProv, getPartidas, getOrdenesCompra, librosProvList, rol, partidasList, setPartidasList, token } = useContext(GlobalContext);

  const [inputFields, setInputFields] = useState([])
  const [optionsLibros, setOptionsLibros] = useState([])
  const [isDisabled, setIsDisabled] = useState(false)
  const [ showMassive, setShowMassive ] = useState(false)

  const [ loading, setLoading ] = useState( false )
  const [ file, setFile ] = useState(null)
  const [ showErrorMassive, setShowErrorMassive ] = useState(false)
  const [ errorMassiveMessage, setErrorMassiveMessage ] = useState(false)

  /*const optionsLibros = [
    { value: 1, label: 'Chocolate' },
    { value: 2, label: 'Strawberry' },
    { value: 3, label: 'Vanilla' }
  ];*/

  useEffect(() => {
    setGlobalLoading( true )

    //if(librosProvList.length === 0)
    getLibrosProv(orden.idProveedor)

    if(parseInt(rol) === 1 || (orden.estatus !== 'en_espera' && orden.estatus !== 'abierta' && orden.estatus !== 'rechazada'))
      setIsDisabled(true)
  }, [orden]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if( librosProvList.length > 0 ){
      var temp = []

      librosProvList.map( item => {
        temp.push({ value: item.idLibro, 
          label: item.titulo,
          //label: <div> <div>{ item.titulo }</div> <div className="item-link">{ " ( Existencia: " + item.librosAlmacen[0].cantidad +  " )" } </div> </div>, 
          //title: <div>{ item.titulo } <br/> <div className={ parseInt(item.librosAlmacen[0].cantidad) < 5 ? "item-link" : "" }>{ " ( Existencia: " + item.librosAlmacen[0].cantidad +  " )" } </div></div>, 
          price: item.precio, 
          cantidad: item.librosAlmacen[0].cantidad,
          isbn: item.codigoIsbn })
      })

      setOptionsLibros( temp )
      getPartidas( orden.idOrden )
    }
  }, [librosProvList]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setInputFields([])

    if(partidasList && partidasList.length > 0) {
      setInputFields(partidasList)
    }
  }, [partidasList]); // eslint-disable-line react-hooks/exhaustive-deps

  const updatePartida = (e) => {
    e.preventDefault();
    setGlobalLoading( true )

    console.log("data tu update", inputFields)
    axios.post(PARTIDAS_UPDATE_API, inputFields, {
			headers: { 'content-type': 'application/json' }
    }).then(result => {
      console.log("result update", result.data)
      setPartidasList(result.data)
      setGlobalLoading( false )

      setShowDetail( false )
      getOrdenesCompra()
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setCallback(false)
      setGlobalLoading( false )
    })
  }

  const handleFormChange = (index, event) => {
    let data = [...inputFields];
    data[index][event.target.name] = event.target.value;

    console.log("item values", data)
    setInputFields(data);
  }

  const addFields = (item) => {
    let newfield = { idPartida: null, idOrden: orden.idOrden, idLibro: item.value, descripcion: '', cantidad: 0, precio: item.price, unidad: 'Pieza', total: 0, estatus: true, cantidadSurtida: 0 }
    setInputFields([...inputFields, newfield])
  }

  const removeFields = (index) => {
    let data = [...inputFields];
    data.splice(index, 1)
    setInputFields(data)
  }

  const getBookName = (idLibro) => {
    let result = optionsLibros.find( o => o.value === idLibro);
    return result ? result : ''
  }

  const showMasiveFile = () => {
    setShowMassive(true)
  }

  const sendForm = (e) => {
    e.preventDefault();
    setGlobalLoading( true )
    setLoading( true )

    var form = document.getElementById('visitorForm')
    var formData = new FormData(form)

    axios.post(PARTIDAS_MASSIVE_API, formData, {
      headers: {
        'Content-type': 'multipart/form-data; charset=utf-8',
        'Authentication': token
      }
    })
    .then(rest => {
      console.log("result uploading massive", rest.data)
      setGlobalLoading( false )
      setLoading( false )
      setShowMassive( false )

      if(rest.data === 'ISBN_NO_EXISTS' || rest.data === 'INVALID_ISBN' || rest.data === 'EMPTY' || rest.data === 'INVALID_PROVIDER'){
        setErrorMassiveMessage(rest.data)
        setShowErrorMassive(true)
      } else
        getPartidas( orden.idOrden )
        getOrdenesCompra()
    })
    .catch(error => {
      console.log("error", error.message)
      setGlobalLoading( false )
      setLoading( false )
    })
  }

  return (
    <div>
      <Modal show={showErrorMassive} onHide={ () => setShowErrorMassive(false) }>
        <Modal.Header closeButton>
          <div className="title-form">{ 'Error - Carga Masiva' }</div>
        </Modal.Header>
        <Modal.Body>
          <div>
            { errorMassiveMessage === 'ISBN_NO_EXISTS' && <div> El Código de Barras de algunos <b>libros / productos</b> no se encuentran en el catálogo. Favor de verificar si el registro del <b>libro / producto</b> es correcto o ingresarlo como nuevo producto en la seccion de libreria. </div> }
            { errorMassiveMessage === 'INVALID_ISBN' && <div> El Código de Barras contiene un <b>formato inválido</b> en el archivo excel. Favor de asegurarse que todas las celdas de la columna <b>Codigo de Barras</b> sean de tipo texto y no tenga formato exponencial. </div> }
            { errorMassiveMessage === 'INVALID_PROVIDER' && <div> El provedor de algunos productos <b>no coincide</b> con el proveedor asignado a esta Orden de Compra. </div> }
            { errorMassiveMessage === 'EMPTY' && <div> El archivo Excel tiene un formato no reconocido o esta vacio. </div> }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" onClick={ () => setShowErrorMassive(false) } className="cancel-btn">{ 'Cerrar' }</button>&nbsp;&nbsp;
        </Modal.Footer>
      </Modal>

      <Modal show={showMassive} onHide={ () => setShowMassive(false) }>
        <Modal.Header closeButton>
          <div className="title-form">{ 'Ordenes de compra - Carga Masiva' }</div>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form id='visitorForm' onSubmit={ sendForm }>
              <div>
                <input type="hidden" name="idOrden" value={ orden.idOrden } />
                <div> Puedes subir un <span style={{ color: "#ae0107" }}>ARCHIVO</span> .xlsx para poder subir varias <b>consignaciones</b> a la vez. </div>
                <br/>
                <input required className='file' type="file" name="Ordenes" onChange={ (e) => setFile(e.target.files[0]) } style={{ fontSize: '11px' }} />
                <br/>
                <div align="right">
                  <Button disabled={ loading } className='single-btn' type="submit">
                    <Spinner animation="border" variant="light" role="status" className={ loading ? 'spin' : 'hide' }/>
                    <span className={ loading ? 'hide' : 'btn-text' }> Guardar </span>
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      <>
        <Container>
          <Row>
            <div>
              <Form id="partidaForm" onSubmit={ updatePartida }>
                { !readOnly && parseInt(rol) === 2 && !isDisabled && 
                  <>
                    <br/>
                    <div align="left">
                      { parseInt(rol) === 2 && <span className="single-alt-btn" onClick={ () => showMasiveFile() } > Carga Masiva </span> }
                    </div>
                    <br/>
                    <Container>
                      <Row>
                        <Col md={ 9 }>
                          <Form.Group className='mb-3'>
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              placeholder="Libros..."
                              isClearable={true}
                              isSearchable={true}
                              name="color"
                              value={null}
                              options={optionsLibros}
                              getOptionLabel={(option) => `${option.label} ( Existencia: ${option.cantidad} )`}
                              onChange={ (e) => addFields(e) }
                            />
                          </Form.Group>
                        </Col>
                        <Col md={ 3 }>
                          { inputFields.length > 0 &&
                            <div align="center">
                              <button type="submit" className="grl-btn">{ 'Guardar' }</button>
                            </div>
                          }
                        </Col>
                      </Row>
                      <Row>
                        <div className="desc-form"> Agrega libros o productos de la lista de arriba y asigna cantidad y descuento a cada uno, o bien carga un archivo excel con la información requerida. Al finalizar, da click en gusrdar para guardar los elementos en la Orden de compra. </div>
                      </Row>
                    </Container>
                  </>
                }

                <Container>
                  {inputFields.map((input, index) => {
                    if(input.idLibro) {
                      let book  = getBookName(input.idLibro)
                      return <>
                        <Row> 
                          <Col> 
                            <div style={{ paddingTop: '10px' }}>
                              <Row> <Col> <div style={{ paddingTop: '10px' }}><b>{ '#' + ((index+1) < 10 ? '0' + (index+1) : (index+1)) + ' ' + book.label }</b></div> </Col> </Row>
                              <Row> <Col> <div style={{ paddingTop: '0px', color: '#8a8a8a' }}>Código de Barras: <span style={{ color: '#aa2d1f' }}>{ book.isbn }</span></div> </Col> </Row>
                              <Row> <Col> <div style={{ paddingTop: '0px', color: '#8a8a8a', marginBottom: '10px' }}>Precio: <span style={{ color: '#aa2d1f' }}>{ CURRENCY_FORMAT.format(input.precio) }</span></div> </Col> </Row>
                            </div> 
                          </Col>
                        </Row>
                        { readOnly ?
                          <Row index={`partida_${index}`} className="align-items-center" style={{ paddingTop: '10px', paddingBottom: '15px' }}>
                            <Col md={ 4 }>
                              <div className="desc-form" style={{ color: '#ae0107' }}> Cantidad </div>
                              <div>{ input.cantidad }</div>
                            </Col>
                            <Col md={ 4 }>
                              <div className="desc-form" style={{ color: '#ae0107' }}> Descuento (%) </div>
                              <div>{ input.descuento }</div>
                            </Col>
                            <Col md={ 4 }>
                              <div className="desc-form" style={{ color: '#ae0107' }}> Impuesto aplicable </div>
                              <div>{ input.iva ? 'Si' : 'No' }</div>
                            </Col>
                          </Row>
                          : 
                          <Row index={`partida_${index}`} className="align-items-center">
                            {/*<Col md={4}>
                              <Form.Group className='mb-3'>
                                <FloatingLabel label="Descripción">
                                  <Form.Control required disabled={isDisabled} name={'descripcion'} value={ input.descripcion } onChange={event => handleFormChange(index, event)} placeholder="" />
                                </FloatingLabel>
                              </Form.Group>
                            </Col>*/}
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <FloatingLabel label="Cantidad">
                                  <Form.Control required disabled={isDisabled} type='number' name={'cantidad'} value={ input.cantidad } onChange={event => handleFormChange(index, event)} placeholder="" />
                                </FloatingLabel>
                              </Form.Group>
                            </Col>
                            {/*<Col md={3}>
                              <Form.Group className='mb-3'>
                                <FloatingLabel label="Precio">
                                  <Form.Control required disabled={true} type='number' name={'precio'} value={ input.precio } onChange={event => handleFormChange(index, event)} placeholder="" />
                                </FloatingLabel>
                              </Form.Group>
                            </Col>*/}
                            <Col md={4}>
                              <Form.Group className='mb-3'>
                                <FloatingLabel label="Descuento (%)">
                                  <Form.Control required disabled={isDisabled} type='number' name={'descuento'} value={ input.descuento } onChange={event => handleFormChange(index, event)} placeholder="" />
                                </FloatingLabel>
                              </Form.Group>
                            </Col>
                            <Col md={4}>
                              <Form.Group className='mb-3'>
                                <Form.Group className='mb-3'>
                                  <FloatingLabel label="Impuesto aplicable">
                                    <Form.Select required disabled={isDisabled} name="iva" value={ input.iva } onChange={event => handleFormChange(index, event)} placeholder="" >
                                      <option value={ 'false' }> No </option>
                                      <option value={ 'true' }> Si </option>
                                    </Form.Select>
                                  </FloatingLabel>
                                </Form.Group>
                              </Form.Group>
                            </Col>
                            <Col md={1}>
                              { parseInt(rol) === 2 && !isDisabled && <X onClick={() => removeFields(index)} className="table-icon" /> }
                            </Col>
                          </Row>
                        }
                      </>
                    }
                  })}
                </Container>
              </Form>
            </div>
          </Row>
        </Container>
      </>
    </div>
  );
}

export default Partidas;
